<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">完成组队</span>
    </p>
    <p class="model-text">完成组队后将无法再添加新成员</p>
    <div slot="footer">
      <comp-button type="default" @click="finishReject">再考虑考虑</comp-button>
      <comp-button @click="finishConfirm">完成</comp-button>
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import Api from '@/api/competition/financialIndex'
import { mapGetters } from 'vuex'

export default {
  name: 'FinishFormTeam',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    CompButton
  },
  computed: {
    ...mapGetters(['competeUser'])
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    finishReject() {
      this.$emit('stateChange', 'myTeam')
    },
    finishConfirm() {
      Api.finishTeamFormUp({
        team_id: this.competeUser.team_id,
        team_state: '1'
      }).then(
        (res) => {
          this.$emit('stateChange', 'myTeamCheck')
        },
        (err) => {}
      )
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.model-text {
  text-align: center;
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #333333;
  line-height: 32px;
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/MyTeam/FinishFormTeam.vue